/**
 * Displays price per unit information.
 *
 * @param {Object} props Component props
 * @param {number} props.price Price
 * @param {string} props.pricePerUnitBase Price per unit base unit of measure (typically lb)
 * @param {number} props.pricePerUnitRatio Ratio to multiply price by to get price per unit
 * @param {number} props.portion Portion of the product (bundles only)
 * @returns {JSX.Element|null}
 */
function PricePerUnitInfo({ portion = 1, price, pricePerUnitBase, pricePerUnitRatio }) {
    const pricePerUnit = (pricePerUnitRatio * price) / portion;
    if (pricePerUnit > price || (pricePerUnitRatio === 1 && portion === 1)) {
        // Do not show if price per unit is greater than overall price or if price per unit ratio is 1
        return null;
    }
    // Below we add 0.005 to the price per unit to prevent rounded amounts
    // from being too low, for legal safety reasons.
    return (
        <p className="text-body-sm text-black">
            ${(pricePerUnit + 0.005).toFixed(2)} / {pricePerUnitBase}
        </p>
    );
}

export default PricePerUnitInfo;
